<template>
    <div class="root">
        <div class="nav">
            <div class="l"><i class="icon"></i><span class="title"><router-link
                        to="/home">深圳市智汇数能科技有限公司</router-link></span></div>
            <div class="r">
                <ul class="menu">
                    <li class="item"><router-link to="/home">首页</router-link></li>
                    <li class="item"><router-link to='/news'>新闻资讯</router-link></li>
                    <li class="item"><router-link to='/about'>联系我们</router-link></li>
                </ul>
            </div>
        </div>
        <router-view class="contentBox" />
        <div class="footer">
            <router-link v-for="(item, i) in paths" :to="item.path" :key="i" class="mr10">
                <span v-if="item.path == '/project'" @click="getFirstProjectType()">{{ item.name }}</span>
                <span v-else>{{ item.name }}</span>
            </router-link>
            <div class="mark">深圳市智汇数能科技有限公司版权所有 2024-2026·<a href="https://beian.miit.gov.cn/" target="_blank"
                    style="color: deepskyblue;font-weight: normal;">粤ICP备2024232379号-1</a></div>
        </div>
    </div>
</template>
<script>
import { getRequest } from '../utils/api'
export default {
    name: 'root',
    data() {
        return {
            projectTypeList: [],
            paths: [{
                path: '/home',
                name: '首页'
            }, {
                path: '/news',
                name: '新闻资讯'
            }, {
                path: '/about',
                name: '联系我们'
            }]
        }
    },
    created() {

    },
    mounted() {
        
    },
    methods: {

    }
}
</script>
<style lang="less">
.root {
    .nav {
        height: 60px;
        display: flex;
        border-bottom: 1px solid #00a3e4;

        .l {
            flex-grow: 1;
            min-width: 300px;
            padding-left: 40px;

            .icon {
                display: inline-block;
                padding: 5px 0;
                width: 30px;
                height: 30px;
                background: url(../assets/logo.png) no-repeat 5px 15px;
                background-size: 25px 25px;
                float: left;
            }

            .title {
                display: inline-block;
                height: 60px;
                line-height: 60px;
                float: left;
                padding-left: 10px;
                font-size: 20px;
                font-weight: bold;
            }
        }

        .r {
            width: 600px;
            padding-right: 60px;

            .menu {
                .item {
                    float: left;
                    width: 100px;
                    line-height: 60px;
                    text-align: center;
                    cursor: pointer;
                    position: relative;

                    .router-link-exact-active.router-link-active {
                        color: #00a3e4;
                        font-weight: bold;
                    }

                    .list {
                        position: absolute;
                        left: 0;
                        top: 60px;
                        padding-top: 13px;
                        z-index: 222;
                        width: 100%;
                        display: none;

                        li {
                            height: 40px;
                            line-height: 40px;
                            color: #fff;
                            background-color: rgba(0, 0, 0, 0.6);
                        }

                        li:hover {
                            background-color: rgba(0, 0, 0, 0.4);
                            color: #00a3e4;
                        }
                    }
                }

                .item:hover {
                    border-bottom: 2px solid #00a3e4;

                    a {
                        color: #00a3e4;
                    }

                    .list {
                        display: block;
                    }
                }
            }
        }
    }

    .nav:hover {
        padding: 10px 0;
        transition: all 0.5s;
    }

    .contentBox {
        min-height: calc(100vh - 165px);
    }

    .footer {
        margin-top: 20px;
        background-color: rgba(0, 0, 0, 0.6);
        min-height: 80px;
        padding: 12px 24px;
        color: #fff;

        .mark {
            text-align: center;
            padding-top: 20px;
        }

        .mr10 {
            padding: 0 20px;
            color: #fff;
            cursor: pointer;
            font-weight: 100;
        }

        .mr10:hover {
            font-size: 16px;
            padding: 0 25px;
        }

        .msgs {
            line-height: 26px;
        }
    }
}</style>
